export default () => ({
  authenticated: false,
  registered: false,
  mobile: false,
})
